// extracted by mini-css-extract-plugin
export default {"payment":"jp","title_row":"kp","border_bottom":"lp","promo_wrapper":"mp","payment_wrapper":"np","label":"op","card_row":"pp","cardcontain":"qp","card_input":"rp","card_error":"sp","card_label":"tp","lock":"up","same_address":"vp","place_order_button":"wp","buttonwrap":"xp","hide_form":"yp","paypal_buttons":"zp","review_button":"Ap","alt_payment":"Bp"};
    if(module.hot) {
      // 1713809675603
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  